// @flow

module.exports = {
  Error: {
    NO_INTERNET: -1,

    UNKNOWN: 0,
  },
};
